import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'

export default function FiliacaoSection({ nomeMae, nomePai, nomeConjuge, allDisabled, onChange }) {
  return (
    <Row className="form-row align-items-start">
      <Col xs={12} sm={4} lg={4}>
        <Form.Group className="required">
          <Form.Label htmlFor="nomeMae">Nome da mãe</Form.Label>
          <Form.Control
            type="text"
            name="nomeMae"
            value={nomeMae}
            onChange={onChange}
            maxLength={100}
            disabled={allDisabled}
            required
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={4} lg={4}>
        <Form.Group className="required">
          <Form.Label htmlFor="nomePai">Nome do pai</Form.Label>
          <Form.Control
            type="text"
            name="nomePai"
            value={nomePai}
            onChange={onChange}
            maxLength={100}
            disabled={allDisabled}
            required
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={4} lg={4}>
        <Form.Group>
          <Form.Label htmlFor="nomeConjuge">Nome do cônjuge</Form.Label>
          <Form.Control
            type="text"
            name="nomeConjuge"
            value={nomeConjuge}
            onChange={onChange}
            maxLength={100}
            disabled={allDisabled}
          />
        </Form.Group>
      </Col>
    </Row>
  )
}
